import { Text, type TextColor, type TextWeight } from '@/components';
import type { CSSProperties, ComponentProps, FC } from 'react';
import { LegendNode } from './LegendNode';

type Props = {
  text: string | null | undefined;
  color?: TextColor;
  weight?: TextWeight;
  style?: CSSProperties;
  textJustify: CSSProperties['justifyContent'];
} & Omit<ComponentProps<typeof LegendNode>, 'childrenJustify'>;

export const LegendText: FC<Props> = (props) => {
  const { text, color, textJustify, weight, style, ...legendNodeProps } = props;
  return (
    <LegendNode childrenJustify={textJustify} {...legendNodeProps}>
      <Text weight={weight} style={style} text={text} color={color} />
    </LegendNode>
  );
};
